<template>
  <div class="page-column">
    <div class="PhysicalFitnessResult">
      <MatchHeader />
      <MatchInfo />
      <MatchMenu />
      <ResultDetail />
      <Footer />
    </div>
  </div>
</template>

<script>
import MatchHeader from '@/views/layout/MatchHeader.vue'
import MatchInfo from '@comm/components/MatchInfo.vue'
import MatchMenu from '@comm/components/MatchMenu.vue'
import Footer from '@/views/layout/Footer.vue'
import ResultDetail from './components/ResultDetail.vue'
export default {
  name: 'PhysicalFitnessResult',
  props: {},
  components: {
    MatchHeader,
    MatchInfo,
    MatchMenu,
    ResultDetail,
    Footer,
  },
  data() {
    return {}
  },

  mounted() {},
  created() {
    window.scrollTo(0, 0)
  },
  methods: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.page-column {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/comm/components/PhysicalFitness/Result.vue